import Component from "vue-class-component";
import moduleStore from "./store/pay";
import Vue from "vue";
import PageState from "./store/state";
import { Prop } from "vue-property-decorator";
import { Toast } from "vant";
import Cookies from "js-cookie";
import { judgeDeviceType } from '@/utils/device'
import LZString from '../../utils/lz-string.min'
/**components**/
interface listItem {
	type: string;
	label: string;
	img: any;
	alt: string;
}
interface BridgeParams {
	appId: any,     //公众号ID，由商户传入     
	timeStamp: any,     //时间戳，自1970年以来的秒数     
	nonceStr: any,      //随机串     
	package: any,
	signType: any,     //微信签名方式：     
	paySign: any //微信签名 
}
@Component({})
@moduleStore.initVuex({
	mutationNames: moduleStore.mutationNames,
	actionNames: moduleStore.actionNames,
})
export default class payComponent extends Vue {
	// 是否需要展示校验手机
	@Prop() isCheckPhone: false;
	@Prop() isVertical: false;
	//1代表只允许微信，0代表只允许支付宝，2或者没有代表都可以
	@Prop() payLimit:number;
	@Prop() choiced:number;
	selected: string = "wx";
	phone: string = "";
	isFocus: boolean = false
	list: Array<listItem> = [
		{
			type: "wx",
			label: "微信支付",
			img: require("./img/wx.svg"),
			alt: "wxpay logo",
		},
		// {
		// 	type: 'blank'
		// },
		{
			type: "zfb",
			label: "支付宝支付",
			img: require("./img/zfb.svg"),
			alt: "alipay logo",
		},
	];
	checkImg= [
		require('/public/images/member/checked0_img.png'),
		require('/public/images/member/checked1_img.png'),
		require('/public/images/member/checked0_img.png'),
		require('/public/images/member/checked0_img.png'),
		require('/public/images/member/checked0_img.png'),
	]
	state = new PageState();

	created(moduleData: IinjectDatas) {
		this.state = <PageState>moduleData.state;
		window.addEventListener('pageshow', (e) => {
			if (e.persisted || (window.performance && 
				window.performance.navigation.type == 2)) {
					const html = document.querySelector('html')
					let fontSizeL = localStorage.getItem('htmlfontsize')
					if(fontSizeL) {
						html.style.fontSize = fontSizeL
					}
			}
		}, false)
	}
	mounted() {
		const html = document.querySelector('html')
		const fontSize = html.style.fontSize
		localStorage.setItem('htmlfontsize', fontSize)
		if(this.payLimit == 1) {
			this.list = this.list.filter(item => item.type !== 'zfb')
			this.selected = 'wx'
		}else if(this.payLimit == 0) {
			this.selected = 'zfb'
			this.list = this.list.filter(item => item.type !== 'wx')
		}else {
			this.selected = 'wx'
		}
	}
	changeCard(item) {
		this.selected = item.type;
		let payReflect = {
			'wx': 0,
			"zfb": 1
		}
		this.$emit('changPayMethod', payReflect[this.selected])
	}
	changeBorder(v) {
		this.isFocus = v
		window.scrollTo(0, 0)
	}
	/**
	 * 
	 * @returns {boolean} 校验通过true
	 */
	phoneCheck() {
		const myreg = /^[1][0-9]{10}$/;
		if(!this.phone) {
			Toast({
        message: "请先输入手机号",
        icon: "none",
				className: 'phone-toast',
				position: 'top',
      })
			this.focus()
			return false
		}
		if (!myreg.test(this.phone)) {
			Toast({
        message: "请输入正确的手机号",
        icon: "none",
				position: 'top',
      })
			return false;
		}
		return true
	}
	phoneChange() {
		this.$emit("phoneChange", this.phone);
	}
	// 聚焦input事件
	focus() {
		(this.$refs.input as any).focus()
	}

	/**
	 * @param {} payInfo 
	 * 支付宝支付
	 */
	aliPay(payInfo: any, succObj?:any) {
		console.log(payInfo, 'JAPI支付宝支付payInfo');
			this.$router.push({path: '/middlePageOfPay', query: {
				info: JSON.stringify({
					...payInfo,
					succObj
				})
			}})
	
	}
	/**
	 * 判断是否支持微信支付逻辑
	 * @param {object} bridgeParams 传入支付的参数对象
	 */
	wxPay(bridgeParams) {
		// 调用微信的发起支付接口
		if (typeof window.WeixinJSBridge == "undefined") {
			if (document.addEventListener) {
				document.addEventListener(
					"WeixinJSBridgeReady",
					this.onBridgeReady,
					false
				);
				return Promise.resolve();
			} else {
				Toast({
					message: "请使用最新版微信打开",
					icon: "none",
					duration: 1000,
					position: "top",
				});
				return Promise.resolve();
			}
			// else if (document.attachEvent) { // eslint-disable-line
			//   document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady); // eslint-disable-line
			//   document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady); // eslint-disable-line
			// }
		} else {
			return this.onBridgeReady(bridgeParams);
		}
	}
	/**
	 * 微信支付逻辑
	 * @param {object} bridgeParams 
	 * @returns {Promise}
	 */
	onBridgeReady(bridgeParams) {
		return new Promise((resolve, reject) => {
			window.WeixinJSBridge.invoke(
				"getBrandWCPayRequest",
				{
					// eslint-disable-line
					...bridgeParams,
				},
				(res) => {
					// 使用以上方式判断前端返回,微信团队郑重提示：
					// res.err_msg将在用户支付成功后返回 ok，但并不保证它绝对可靠。
					if (res.err_msg == "get_brand_wcpay_request:ok") {
						// 清空本地缓存
						Cookies.remove("USER_CODE");
						resolve('ok')
						// 跳转到成功页
					} else {
						reject()
					}
				}
			);
		});
	}

    /**h5支付-在普通浏览器中打开 */
    h5Pay(payTypeIndx,payInfo: any, succObj?: any) {
      let infoCompress = LZString.compressToBase64(JSON.stringify({
            ...payInfo,
        }))
        console.log('---H5支付infoCompress',infoCompress)
        let payType ='';
        payType = payTypeIndx===1?'alipayH5':'wxpayH5';
        this.$router.push({
        path: '/middlePageOfPay',
        query: {
            info: infoCompress,
            // from: 'sameType',
            payType:payType,
            desc:''
        },
        });
    }
}
